import styles from "./oldBrowserModal.module.scss";
import type { AccordionButtonProps } from "@monta/design-system";
import clsx from "clsx";
import { ChevronTop } from "@monta/icons";
interface LabelButtonProps extends AccordionButtonProps {
  title: string;
}
const LabelButton = (props: LabelButtonProps) => {
  const { title, active, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={clsx(styles["label"], active && styles["label--active"])}
    >
      <span>{title}</span>
      <ChevronTop
        className={clsx(
          styles["label__icon"],
          active && styles["label__icon--rotate"],
        )}
      />
    </div>
  );
};
export default LabelButton;
